import { ThemeProvider, createTheme } from '@mui/material/styles';
import 'App.scss';
import { persistor, store } from 'redux-setup/store';
import { Provider } from 'react-redux';
import AppRouter from 'router';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'shared-components';
import { useState } from 'react';
import AppWrapper from 'components/AppWrapper';

function App() {
  const [theme, setTheme] = useState<boolean>(false);
  const darkTheme = createTheme({
    palette: {
      mode: theme ? 'light' : 'dark',
    },
    typography: {
      allVariants: {
        fontFamily:
          "work-sans, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        textTransform: 'none',
      },
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          arrow: {
            color: theme ? '#FFFFFF' : '#000000',
          },
          tooltip: {
            backgroundColor: theme ? '#FFFFFF' : '#000000',
            color: theme ? '#333333' : '#FFFFFF',
            padding: '8px 12px',
            fontSize: '12px',
            fontWeight: 500,
            border: `1px solid ${theme ? '#E5E7EB' : '#000'}`,
            borderRadius: '4px',
            boxShadow: theme
              ? '0px 4px 6px rgba(0, 0, 0, 0.05)'
              : '0px 4px 6px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
  });
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={darkTheme}>
            {/* <Loader /> */}
            <AppWrapper>
              <AppRouter setTheme={setTheme} />
            </AppWrapper>
            <Toaster />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
